import { useCallback, useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import IconifyIcon from '../../../wrappers/IconifyIcon';
import { getBankStatementBalance } from '../../../../services/bankStatement';

const REFRESH_MS = 5 * 60 * 1000; // refresh every 5 min

const formatInr = (value) =>
  `₹${Number(value).toLocaleString('en-IN', {
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
  })}`;

const BankBalance = () => {
  const [balance, setBalance] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchBalance = useCallback(async () => {
    try {
      const res = await getBankStatementBalance();
      if (res && res.success === false) {
        setBalance(null);
        setError(res.message || 'Unavailable');
        return;
      }
      const amount = res?.data?.current_balance;
      if (amount == null) {
        setBalance(null);
        setError('Unexpected response');
      } else {
        setBalance(amount);
        setError(null);
      }
    } catch (err) {
      setError(err?.response?.data?.message || err?.message || 'Failed to load');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchBalance(); }, [fetchBalance]);

  useEffect(() => {
    const id = setInterval(fetchBalance, REFRESH_MS);
    const onFocus = () => fetchBalance();
    window.addEventListener('focus', onFocus);
    return () => {
      clearInterval(id);
      window.removeEventListener('focus', onFocus);
    };
  }, [fetchBalance]);

  const title = error
    ? `Bank balance: ${error}`
    : balance != null
      ? `Bank balance: ${formatInr(balance)}`
      : 'Loading bank balance…';

  return (
    <div className="topbar-item px-2" title={title}>
      <div className="d-flex align-items-center gap-2">
        <IconifyIcon icon="bx:building-house" className="fs-18 text-success" />
        <div className="d-none d-md-flex flex-column lh-sm">
          <span className="text-muted small">Bank Balance</span>
          {loading && balance == null && !error ? (
            <Spinner animation="border" size="sm" className="align-self-start" />
          ) : (
            <span className={error ? 'fw-semibold text-muted' : 'fw-semibold text-success'}>
              {balance != null ? formatInr(balance) : '—'}
            </span>
          )}
        </div>
        {/* Mobile: icon + value only */}
        <span className={`d-md-none ${error ? 'fw-semibold text-muted' : 'fw-semibold text-success'}`}>
          {loading && balance == null && !error
            ? '…'
            : balance != null
              ? formatInr(balance)
              : '—'}
        </span>
      </div>
    </div>
  );
};

export default BankBalance;
